import { Component, input, model, output, ChangeDetectionStrategy } from '@angular/core';
import { CheckboxComponent } from '@cumlaude/shared-components-inputs';
import { IconComponent } from '@cumlaude/shared-components-icons';

@Component({
	selector: 'app-data-export-row',
	templateUrl: './data-export-row.component.html',
	styleUrls: ['./data-export-row.component.scss'],
	imports: [CheckboxComponent, IconComponent],
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DataExportRowComponent {
	primary = input.required<string>();

	secondary = input.required<string>();

	selected = model.required<boolean>();

	inCategorie = input.required<boolean>();

	showEditDelete = input<boolean>(false);

	first = input<boolean>(false);

	editClicked = output<boolean>();

	deleteClicked = output<boolean>();
}
